module.exports = __webpack_public_path__ + "img/redx.66010999.svg";